module.exports = __webpack_public_path__ + "img/pochinki.f32184cf.jpg";